export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      serviceFunctionName: "御用聞き機能",
      ordertakeSetting: {
        jingleFile: {
          fileName: "jingle.mp3",
          contentType: "audio/mpeg",
          fileUri: "/mp3/img01.mp3",
          fileSize: 1024,
          thumbnailUri: "/images/img01.png"
        },
        serviceName: "サービス名設定",
        ordertakeGuideMessage: " 御用聞きガイドメッセージ",
        ordertakeGuideSound: {
          fileName: "guide.mp3",
          contentType: "audio/mpeg",
          fileUri: "/mp3/img01.mp3",
          fileSize: 1024,
          thumbnailUri: "/images/img01.png"
        },
        ordertakeBtns: [
          {
            defaultFocusFlg: 1,
            btnName: "ボタン名",
            iconFile: {
              fileName: "01.png",
              contentType: "image/png",
              fileUri: "/images/img01.png",
              fileSize: 1024,
              thumbnailUri: "/images/img01.png"
            },
            labelText: "ラベル名",
            assignedKey: 2
          }
        ],
        ordertakeRequestAcceptionMessage: "御用聞き依頼受付メッセージ",
        ordertakeRequestAcceptionSound: {
          fileName: "aaa.mp3",
          contentType: "audio/mpeg",
          fileUri: "/mp3/img01.mp3",
          fileSize: 1024,
          thumbnailUri: "/images/img01.png"
        },
        ordertakeAcceptionCancelMessage: "御用聞き受付キャンセルメッセージ",
        ordertakeAcceptionCancelSound: {
          fileName: "aaa.mp3",
          contentType: "audio/mpeg",
          fileUri: "/mp3/img01.mp3",
          fileSize: 1024,
          thumbnailUri: "/images/img01.png"
        },
        ordertakeRequestCancelMessage: "御用聞き依頼キャンセルメッセージ",
        ordertakeRequestCancelSound: {
          fileName: "aaa.mp3",
          contentType: "audio/mpeg",
          fileUri: "/mp3/img01.mp3",
          fileSize: 1024,
          thumbnailUri: "/images/img01.png"
        }
      }
    }
  }
}